module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Regular.afa934aaa64bf5f1211fa5a2856ef53d.woff";